import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  header: {
    position: "relative",
    top: 0,
    backgroundColor: "#fff",
    color: "#000",
    padding: "0 !important",
    display: "flex",
    flexDirection: "column",
    boxShadow: "none",
  },
  logo: {
    "& img": {
      aspectRatio: "2",
      objectFit: "contain",
      objectPosition: "center",
      maxWidth: "80px",
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      "& img": {
        maxWidth: "120px",
      },
    },
  },
  topMenuItemsContainer: {
    flex: 1,
    gap: "0.875rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  topMenuItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "10px",
    fontWeight: "bold",
    color: (props) => (props.theme === "light" ? "#000000" : "#ffffff"),
    textDecoration: "none",
    textTransform: "uppercase",
    padding: "inherit",
    cursor: "pointer",
    textWrapMode: "nowrap",
    padding: "0.5rem 1rem",
    textAlign: "center",
    boxShadow: theme.shadows[1],
    "&:hover": {
      boxShadow: theme.shadows[3],
    },
    "&:first-child": {
      paddingLeft: 0,
    },
    "&:last-child": {
      paddingRight: 0,
    },
  },
  mainMenu: {
    minHeight: "auto",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: (props) =>
      `3px solid ${props.theme === "light" ? "#57575710" : "#99999910"}`,
  },
  mainMenuMobile: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "3px solid",
    borderImage: "linear-gradient(to right, #60b3e8, #1c3089) 1",
  },
  menuItem: {
    flexGrow: 1,
    fontSize: "10px",
    fontWeight: "bold",
    color: (props) => (props.theme === "light" ? "#0C477F" : "#90bde7"),
    textDecoration: "none",
    textTransform: "uppercase",
    padding: "inherit",
    cursor: "pointer",
    textWrapMode: "nowrap",
    padding: "0.5rem",
    textAlign: "center",
    "&:hover": {
      color: "#0073aa",
    },
    "&:first-child": {
      paddingLeft: 0,
    },
    "&:last-child": {
      paddingRight: 0,
    },
    "&:not(:last-child)": {
      borderRight: (props) =>
        `1px dotted ${props.theme === "light" ? "#57575750" : "#99999950"}`,
    },
  },
  drawerList: {
    width: 250,
  },
  drawerListItem: {
    "& .MuiTypography-root": {
      display: "flex",
      alignItems: "center",
      textTransform: "capitalize",
      color: "inherit !important",
      fontSize: "inherit",
    },
  },
  contextDivider: {
    margin: "0 2rem",
    height: "1.5rem",
    color: "#00000060",
    width: "2px",
  },
  popoverContainer: {
    "& .MuiPaper-root": {
      minWidth: "200px",
      backgroundColor: "transparent !important",
      boxShadow: "none",
    },
  },
  popoverContent: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: (props) =>
      props.theme === "light" ? "#ffffff" : "#3C3C3C",
    boxShadow: theme.shadows[1],
    padding: "0.5rem",
  },
  popoverLink: {
    textDecoration: "none",
    color: (props) => (props.theme === "light" ? "#0C477F" : "#90bde7"),
    padding: "0.5rem",
    "&:hover": {
      background: "#00000020",
      color: (props) => (props.theme === "light" ? "#0073aa" : "#6892b9"),
    },
    "&:not(:last-child)": {
      borderBottom: "1px dotted",
    },
  },
  loginButton: {
    borderRadius: "25px",
    padding: "0.5rem 1rem",
    fontSize: "10px",
    fontWeight: "700",
    textTransform: "uppercase !important",
    color: "#231f1f",
    backgroundColor: "#60b3e8",
    "&:hover": {
      color: "#161616",
      backgroundColor: "#4794c5",
      textDecoration: "underline",
    },
  },
  authenticateContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      gap: "1rem",
    },
  },
  authenticateButtons: {
    padding: 0,
    "&:hover": {
      outline: "2px solid",
      textDecoration: "none",
    },
  },
  home: {
    display: "none",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: "block",
    },
  },
  shoppingBadge: {
    "& .MuiBadge-badge": {
      padding: "1px",
    },
  },
  profileIcon: {
    color: "white",
    mixBlendMode: "difference",
  },
  menuIcon: {
    margin: 0,
    padding: 0,
    color: "white",
    mixBlendMode: "difference",
  },
  circularProgress: {
    width: "20px !important",
    height: "20px !important",
  },
  cssMenu: {
    flex: 1,
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
  },
  cssMenuItem: {
    flex: 1,
    width: "fit-content",
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "center",
    "&:hover > $cssMenuLink": {
      backgroundColor: (props) =>
        props.theme === "light" ? "#e0e0e0" : "#2f2f2f",
    },
    "&:hover > $cssSubmenu": {
      display: "flex",
    },
    "&:first-child": {
      paddingLeft: 0,
    },
    "&:last-child": {
      paddingRight: 0,
    },
    "&:not(:last-child)": {
      borderRight: (props) =>
        `1px dotted ${props.theme === "light" ? "#57575750" : "#99999950"}`,
    },
    "& > $cssMenuLink": {
      width: "100%",
      fontSize: "1vw",
      [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
        fontSize: "0.9vw",
      },
      [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
        fontSize: "0.7vw",
      },
    },
  },
  cssSubmenuItem: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    "&:not(:last-child)": {
      borderBottom: (props) =>
        `1px dotted ${props.theme === "light" ? "#57575750" : "#99999950"}`,
    },
    "& > $cssMenuLink": {
      width: "100%",
      padding: "0.5rem 1rem",
    },
    "&:hover > $cssMenuLink": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiTypography-root": {
      display: "flex",
      alignItems: "center",
      fontSize: "inherit",
      color: "inherit !important",
    },
  },
  cssMenuLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textWrapMode: "nowrap",
    textDecoration: "none",
    color: (props) => (props.theme === "light" ? "#0C477F" : "#90bde7"),
    fontSize: "10px",
    fontWeight: "bold",
    textTransform: "uppercase",
    padding: "0.5rem 1rem",
    width: "100%",
    "&:hover": {
      color: "#0073aa",
    },
  },
  cssSubmenu: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "absolute",
    top: "100%",
    left: 0,
    display: "none",
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (props) =>
      props.theme === "light" ? "#ffffff" : "#3C3C3C",
    boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
    zIndex: 1,
    "& $cssMenuItem": {
      width: "100%",
      borderRight: "0",
    },
    "& $cssMenuLink": {
      justifyContent: "flex-start",
    },
    "&:not([data-level='1'])": {
      top: 0,
      left: "100%",
    },
  },
  iconOpen: {
    display: "none !important",
  },
  iconClose: {
    display: "none !important",
  },
  topMenu: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.5rem 0.875rem",
    borderBottom: "3px solid",
    minHeight: "28px",
  },
  authenticateContext: {
    gap: "4px",
    display: "flex",
    alignItems: "center",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "8px",
    backgroundColor: "#fff",
    borderRadius: "4px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    maxWidth: "150px",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "none",
    },
  },
  userFinancialStatus: {
    fontSize: "0.8rem",
    color: "#666",
  },
  userName: {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: "#333",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      fontSize: "1rem",
    },
  },
  userStatus: {
    fontSize: "0.8rem",
    color: "#999",
  },
}));
